import { useCallback } from "react";
import { VariaveisAmbiente } from "../../../../config";
import { useApiBase } from "../../base/api-base";
import { PedidoDadosModelPut } from "../../../../model/api/pedidos/pedido-dados-model";

export function usePutPedidoDados() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const putPedidoDados = useCallback(
        (empresaId: string, model: PedidoDadosModelPut) => {
            return invocarApi({
                url: `/${VariaveisAmbiente.pedidosVersion}/empresa/${empresaId}/pedido-salao-dados/${model.id}`,
                method: "PUT",
                baseURL: `${VariaveisAmbiente.apiPedidosUrl}/api`,
                data: model,
                enviarTokenUsuario: true,
            });
        },
        [invocarApi]
    );

    return {
        ...outrasPropriedades,
        putPedidoDados,
    };
}